if (!customElements.get('announcement-bar')) {
  class AnnouncementBar extends HTMLElement {
    connectedCallback() {
      if (sessionStorage.getItem('cc-theme-announcement-dismissed') === 'true' && !Shopify.designMode) {
        this.hidden = true;
        return;
      }

      this.announcement = this.querySelector('.announcement');
      this.backgrounds = this.querySelectorAll('.announcement-bg');

      const observer = new MutationObserver(this.mutationCallback.bind(this));
      const config = { attributes: true, attributeFilter: ['class'] };
      this.querySelectorAll('.slideshow__slide').forEach((el) => {
        observer.observe(el, config);
      });

      this.querySelector('.announcement__close').addEventListener('click', this.close.bind(this)); this.initCountdown();
    }

    mutationCallback(mutationList) {
      // eslint-disable-next-line no-restricted-syntax
      for (const mutation of mutationList) {
        if (mutation.type === 'attributes') {
          if (mutation.target.classList.contains('is-active')) {
            this.setActiveSlide(mutation.target);
          }
        }
      }
    }

    setActiveSlide(slide) {
      this.style.setProperty('--announcement-text-color', slide.dataset.textColor);
      this.backgrounds.forEach((el) => {
        el.classList.toggle('is-active', el.dataset.index === slide.dataset.index);
      });
        this.initCountdown();
    }

    close() {
      sessionStorage.setItem('cc-theme-announcement-dismissed', 'true');
      this.hidden = true;
    }

    
    initCountdown() {
      const countdowns = this.querySelectorAll(".countdown");

      countdowns.forEach((el) => {
        if (el.dataset.loaded) return;
        el.dataset.loaded = true;

        const dateStr = el.dataset.date.replace(" ", "T");
        const countdownDate = new Date(dateStr).getTime();

        const updateCountdown = () => {
          const now = new Date().getTime();
          const distance = countdownDate - now;

          if (distance < 0) {
            el.innerHTML = "⚡ Oferta finalizada";
            return;
          }


const days = Math.floor(distance / (1000 * 60 * 60 * 24));
const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
const seconds = Math.floor((distance % (1000 * 60)) / 1000);

// 👉 Lógica dinámica
if (days > 0) {
  el.innerHTML = `${days} días ${hours} h ${minutes} m ${seconds}s`;
} else {
  el.innerHTML = `${hours} h ${minutes} m ${seconds} s`;
}

        };

        updateCountdown();
        setInterval(updateCountdown, 1000);
      });
    }

  }

  customElements.define('announcement-bar', AnnouncementBar);


}


function adjustHeaderPosition() {
  const bar = document.querySelector("announcement-bar");
  const header = document.querySelector(".header");

  if (!bar || !header) return;

  const height = bar.offsetHeight;

  header.style.top = height + "px";
}

document.addEventListener("DOMContentLoaded", adjustHeaderPosition);
setTimeout(adjustHeaderPosition, 300);
setTimeout(adjustHeaderPosition, 1000);


/*const link = e.target.closest("announcement-bar a");




document.addEventListener("pointerup", function (e) {

  const btn = e.target.closest(".announcement-cta");

  if (btn) {
    const url = btn.dataset.url;

    if (url) {
      window.open(url, "_self");
    }
  }

}, true);



document.addEventListener("touchend", function (e) {
  const btn = e.target.closest(".announcement-cta");

  if (btn) {
    const url = btn.dataset.url;
    if (url) window.open(url, "_self");
  }
}, true);

*/


